import { init } from 'commandbar';
import { useEffect, useState } from 'react';

export const useCommandbar = (customerId?: string, userId?: number): void => {
    const [initDone, setInitDone] = useState(false);

    useEffect(() => {
        if (!userId || !customerId) {
            return;
        }

        if (!initDone) {
            init(customerId);
            setInitDone(true);
        }

        if (userId) {
            window.CommandBar.boot(userId.toString());
        }

        return () => {
            window.CommandBar.shutdown();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId]);
};
